/** AWS Terrain Tiles (Mapzen), terrarium-encoded PNG elevation tiles. */
export const DEM_TILES_URL = 'https://s3.amazonaws.com/elevation-tiles-prod/terrarium/{z}/{x}/{y}.png';
export const DEM_ENCODING = 'terrarium';
export const DEM_ATTRIBUTION =
  '<a href="https://registry.opendata.aws/terrain-tiles/">Terrain Tiles</a> (Mapzen/AWS)';

export const demTileUrl = (z: number, x: number, y: number) =>
  DEM_TILES_URL.replace('{z}', String(z)).replace('{x}', String(x)).replace('{y}', String(y));
